import React, { useEffect, useState } from "react";
import RadioPromo from "./radioPromo";
import { PromotionMediaObject, PromotionType } from "types/promoType";
import TvPromo from "./tvPromo";
import PressPromo from "./pressPromo";
import { SongWithUrls } from "types/response-type";
import Toast from "components/toast";
import { GetActiveArtist } from "services/user/getUser";
import api from "services/axiosInstance";

interface IProps {
  types: PromotionType[];
  setMedia: (key: PromotionType, value: any) => void;
  media?: PromotionMediaObject;
}
const StepTwo = ({ types, setMedia, media }: IProps) => {
  const [songs, setSongs] = useState<SongWithUrls[]>([]);
  const [songsLoading, setSongsLoading] = useState(false);
  const [trackTitles, setTrackTitles] = useState<string[]>([]);

  const artist = GetActiveArtist();

  const GetDiscography = async () => {
    setSongsLoading(true);
    try {
      const { data } = await api.get(`/songs/artist/${artist?.id}`);
      const songs: SongWithUrls[] = data.data;

      if (!songs || songs.length === 0) {
        Toast({ error: "No songs found" });
        return;
      }

      setSongs(songs);
      let trackNames: string[] = [];
      for (let i = 0; i < songs?.length; i++) {
        trackNames.push(songs[i].title);
      }
      setTrackTitles([...trackNames]);
    } catch (error) {
      Toast({ error });
    } finally {
      setSongsLoading(false);
    }
  };

  useEffect(() => {
    GetDiscography();
  }, []);
  return (
    <div>
      {types.includes("Radio Promotion") && (
        <RadioPromo
          setMedia={(value) => setMedia("Radio Promotion", value)}
          media={media?.["Radio Promotion"]}
          songs={trackTitles}
          songsLoading={songsLoading}
        />
      )}
      {types.includes("TV Promotion") && (
        <TvPromo
          setMedia={(value) => setMedia("TV Promotion", value)}
          media={media?.["TV Promotion"]}
        />
      )}
      {types.includes("Blog/Press Release") && (
        <PressPromo
          setMedia={(value) => setMedia("Blog/Press Release", value)}
          media={media?.["Blog/Press Release"]}
          songs={trackTitles}
          songsLoading={songsLoading}
        />
      )}
    </div>
  );
};

export default StepTwo;
